import { render, staticRenderFns } from "./AdminCustomersEditScreen.vue?vue&type=template&id=2260eb84&"
import script from "./AdminCustomersEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminCustomersEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports